export default __webpack_public_path__ + "static/avatar_group-5504e69fa3593eedefaec112554a29f2.svg";